<div class="d-flex flex-column w-100">
  <div class="d-flex flex-wrap flex-sm-nowrap container gap-3">
    <div class="d-flex flex-column col-12 col-sm-6">
      <app-ashgrid-appellation class="mb-0"></app-ashgrid-appellation>

      <!-- INFO Headline -->
      <div class="d-flex flex-column mt-5">
        <p class="fw-normal" style="font-size: 56px; line-height: normal;">Log in</p>
      </div>
    </div>

    <div class="d-flex flex-column col-12 col-sm-6 mt-3 mt-sm-0 mxw-420px">
      <!-- INFO Sign in with Google Button -->
      <div class="d-flex w-100 mt-auto mb-3 gap-2">
        <button mat-stroked-button class="w-100 mb-2 px-3 py-4 rounded-3e border border-gray" color="primary" [disabled]="inProgress" (click)="signInWithGoogle()">
          <div class="d-flex w-100">
            <!-- INFO Google Icon -->
            <app-google-icon class="w-24px h-24px"></app-google-icon>
            <span class="ms-2 my-auto mat-body-1 fw-bold text-black">Google</span>
          </div>
        </button>

        <button mat-stroked-button class="w-100 px-3 py-4 rounded-3e border border-gray" color="primary" [disabled]="inProgress" (click)="signInWithApple()">
          <div class="d-flex w-100">
            <!-- INFO Apple Icon -->
            <app-apple-icon class="w-24px h-24px"></app-apple-icon>
            <span class="ms-2 my-auto mat-body-1 fw-bold text-black">Apple</span>
          </div>
        </button>
      </div>

      <form [formGroup]="form" class="d-flex flex-column w-100 mt-4">
        <span *ngIf="showError" class="mb-3 mat-caption text-danger">{{ errorText }}</span>

        <!-- INFO Email -->
        <mat-form-field class="w-100" appearance="outline">
          <mat-label>Email</mat-label>
          <input matInput formControlName="email" type="email" placeholder="Email">
          <mat-icon matSuffix fontSet="material-symbols-outlined">mail</mat-icon>
        </mat-form-field>

        <!-- INFO Password -->
        <!-- INFO https://stackoverflow.com/questions/50303454/how-to-use-the-new-material-design-icon-themes-outlined-rounded-two-tone-and -->
        <mat-form-field appearance="outline">
          <mat-label>Password</mat-label>
          <input matInput formControlName="password" placeholder="Password" [type]="hide ? 'password' : 'text'">
          <button mat-icon-button matSuffix (click)="hide = !hide" [attr.aria-label]="'Hide password'"
                  [attr.aria-pressed]="hide">
            <mat-icon fontSet="material-symbols-outlined">{{hide ? 'visibility_off' :
              'visibility'}}</mat-icon>
          </button>
        </mat-form-field>

        <!-- INFO Reset Password -->
        <p class="d-flex w-100 mat-body">
          <a [routerLink]="['/', 'reset', 'password']" [queryParams]="queryParams" class="ms-auto text-primary">Reset password?</a>
        </p>

        <!-- INFO Submit Button -->
        <!-- px-3 py-2 -->
        <button mat-flat-button class="my-4 px-3 py-4 fw-bold rounded-3e" color="primary" [disabled]="inProgress || form.invalid" (click)="signInWithEmailAndPassword()">
          <span class="my-auto mat-body-1 fw-bold">Log in</span>
        </button>
      </form>

      <!-- INFO Don’t have an AshGridX account? Sign up -->
      <p class="mx-auto mb-auto p-2e mat-body-1">
        Don't have an AshGridX account?
        <a [routerLink]="['/', 'create', 'account']" [queryParams]="queryParams" class="ms-1 text-primary">Sign up</a>
      </p>
    </div>
  </div>
</div>
